import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ReactiveComponentModule } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { CoachingPlanComponent } from 'presentation/app-sidebar/sidebar-coaching-plan/coaching-plan.component';
import { PhaseSectionModule } from 'presentation/app-sidebar/sidebar-coaching-plan/plan-phase/phase-section/phase-section.module';
import { PlanPhaseComponent } from 'presentation/app-sidebar/sidebar-coaching-plan/plan-phase/plan-phase.component';

import { AppPrimengModule } from '../../../app-primeng.module';

@NgModule({
	declarations: [PlanPhaseComponent, CoachingPlanComponent],
	exports: [CoachingPlanComponent],
	imports: [
		FormsModule,
		CommonModule,
		RouterModule,
		AppPrimengModule,
		NgScrollbarModule,
		PhaseSectionModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		ReactiveComponentModule,
	],
})
export class CoachingPlanModule {}
